import React from 'react';

// 1. Compass / Globe (360-Degree Perspective)
const GlobeIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="2" y1="12" x2="22" y2="12"></line>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </svg>
);

// 2. Users / Board (Private Advisory Board)
const UsersIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
);

// 3. Layers / Lenses (Tailored Analytical Lenses)
const LayersIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
        <polyline points="2 17 12 22 22 17"></polyline>
        <polyline points="2 12 12 17 22 12"></polyline>
    </svg>
);

// 4. Shield / Safety (Deliberate Stewardship)
const ShieldIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
);

const BENEFITS = [
    {
        icon: <GlobeIcon />,
        title: 'A Broader Perspective',
        description: 'Escape the pressure of rapid-fire markets. MAM expands your view, providing the comprehensive clarity you need to evaluate hidden risks, think wisely, and act with confidence.',
    },
    {
        icon: <UsersIcon />,
        title: 'Your Private Advisory Board',
        description: 'Never rely on a single algorithm. Our multi-agent ecosystem rigorously debates every financial scenario, filtering out market noise and protecting your family from confirmation bias.',
    },
    {
        icon: <LayersIcon />,
        title: 'Tailored Analytical Lenses',
        description: 'Examine your choices from every angle. Engage our specialized AI personas—Magnolia, Camellia, and Peony—to analyze complex data through the distinct lenses of stability, preservation, and growth.',
    },
    {
        icon: <ShieldIcon />,
        title: 'Deliberate Stewardship',
        description: 'Protect your family’s future. With built-in oversight layers and deep-dive risk assessment, our platform ensures every decision prioritizes long-term responsibility over short-term trends.',
    },
];

export const Benefit = () => {
    return (
        <section className="benefits section" id="benefits">
            <div className="container">
                <div className="section__header">
                    <span className="section__badge">Benefits</span>
                    <h2 className="section__title">Why Choose MAM</h2>
                    <p className="section__description">
                        Discover how our platform empowers your family to navigate complexities with clarity and confidence.
                    </p>
                </div>

                <div className="benefits-grid">
                    {BENEFITS.map((benefit) => (
                        <article key={benefit.title} className="feature-card">
                            <div className="feature-card__icon">{benefit.icon}</div>
                            <h3 className="feature-card__title">{benefit.title}</h3>
                            <p className="feature-card__description">{benefit.description}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
